<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E6%BA%AF%E6%BA%90/PhotoshopExtension_Image.png"
			alt="" />
		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">农产品质量安全溯源管理</div>
		<div class="desc">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于区块链技术，实现产品从农业种养殖过程到餐桌的全链路全生命周期追湖，动态监控生产过程和窜货风险，通过区块链技术与LBS定位技术，实时预警异常流向，保障食品安全和销售秩序，提升渠道管控效率。
		</div>
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">赋予商品数据价值，增加产业发展后劲</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E6%BA%AF%E6%BA%90/%E6%BA%AF%E6%BA%90.png"
			alt="" />
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E6%BA%AF%E6%BA%90/%E6%BA%AF%E6%BA%90%E4%BB%B7%E5%80%BC.png"
			alt="" />
		<!-- <img style="width: 70%;margin: 10px 0;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E6%BA%AF%E6%BA%90/%E6%BA%AF%E6%BA%90%E6%B5%81%E7%A8%8B%20.png"
			alt="" /> -->

		<img style="width: 70%;margin-top: 10px;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E6%BA%AF%E6%BA%90/%E6%BA%AF%E6%BA%90%E7%A0%81.png"
			alt="" />
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 70%;
		font-size: 24px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
		color: rgb(86 146 48);
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>